import React from 'react';
import { Star } from 'lucide-react';
export default function DriverRating({ averageRating = 0, reviewCount = 0 }) {
  return <span className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-700"><Star className="h-4 w-4 text-brand-orange-500 fill-current" aria-hidden="true" />{reviewCount ? `${Number(averageRating).toFixed(1)} / 5 · ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}` : 'No reviews yet'}</span>;
}
